import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ConfService} from '../../conf.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'custom-operation-edit',
  templateUrl: './custom-operation-edit.component.html',
  styleUrls: ['./custom-operation-edit.component.css']
})
export class CustomOperationEditComponent implements OnInit {

  partner: any;
  account: string;
  operation: string;
  items: any;
  constructor(private confPost: ConfService, private route: ActivatedRoute, public platform: LeftpanelComponent) { }

  ngOnInit() {
    this.route.queryParams
        .subscribe(params => {
          this.partner = params.partner;
          this.account = params.account;
          this.operation = params.operation;
          this.confPost.getCustomOperation(params.partner, params.account, params.operation).subscribe(data => {
            this.items = data;
          }, error => {
              this.platform.handleErrorGracefully(error, 'Error while retrieving custom operations. Please try again after sometime.');
          });
        });
  }

}
